import { DocstoreSections, sectionsValues } from "../../../../../model";
import { FieldConfig } from "./types";

export const qualityConfirmationTypes = [
  "Документ о качестве бетонной смеси",
  "Сертификат качества",
  "Паспорт качества",
  "Паспорт",
  "Декларация о соответствии",
  "Сертификат соответствия",
  "Информационное письмо",
  "Санитарно-эпидемиологическое заключение (СЭЗ)",
  "Свидетельство государственной регистрации",
  "Сертификат пожарной безопасности",
];

const fileType: FieldConfig = {
  title: "Тип файла",
  name: "fileType",
  type: "select",
  required: true,
  options: sectionsValues.map((section) => ({
    label: section,
    value: section,
  })),
};

const qualityConfirmationType: FieldConfig = {
  title: "Вид ДПК",
  name: "qualityConfirmationType",
  type: "select",
  required: true,
  options: qualityConfirmationTypes.map((type) => ({
    label: type,
    value: type,
  })),
};

const documentName: FieldConfig = {
  title: "Наименование документа",
  name: "documentName",
  type: "input",
  required: true,
};

const description: FieldConfig = {
  title: "Описание",
  name: "description",
  type: "input",
  required: false,
};

const documentNumber: FieldConfig = {
  title: "Номер документа",
  name: "documentNumber",
  type: "input",
  required: true,
};

const issueDate: FieldConfig = {
  title: "Дата выдачи документа",
  name: "issueDate",
  type: "date",
  required: true,
};

const issuingOrganization: FieldConfig = {
  title: "Организация, выдавшая документ",
  name: "issuingOrganization",
  type: "input",
  required: true,
};

const documentCode: FieldConfig = {
  title: "Шифр, указанный в документе",
  name: "documentCode",
  type: "input",
  required: true,
};

const pages: FieldConfig = {
  title: "Лист",
  name: "pages",
  type: "input",
  required: false,
};

const producer: FieldConfig = {
  title: "Производитель",
  name: "producer",
  type: "input",
  required: false,
};

export const docstoreUploadModalConfig: Record<
  Exclude<
    (typeof DocstoreSections)[keyof typeof DocstoreSections],
    | (typeof DocstoreSections.NORMATIVE)
    | (typeof DocstoreSections.EXECUTIVE_DRAWING)
    | (typeof DocstoreSections.TRASH)
  >,
  FieldConfig[]
> = {
  [DocstoreSections.PERMITS]: [
    fileType,
    documentName,
    description,
    documentNumber,
    issueDate,
    issuingOrganization,
  ],
  [DocstoreSections.WORKING_DRAFT]: [
    fileType,
    documentName,
    description,
    issueDate,
    issuingOrganization,
    documentCode,
    pages,
  ],
  [DocstoreSections.WORK]: [
    fileType,
    documentName,
    description,
    issueDate,
    issuingOrganization,
    documentCode,
    pages,
  ],
  [DocstoreSections.EXECUTIVE_SCHEME]: [
    fileType,
    documentName,
    description,
    issueDate,
    issuingOrganization,
    documentCode,
    pages,
  ],
  [DocstoreSections.CERTIFICATE]: [
    fileType,
    qualityConfirmationType,
    documentName,
    description,
    documentNumber,
    issuingOrganization,
    issueDate,
    producer,
  ],
  [DocstoreSections.LABORATORY_DATA]: [
    fileType,
    documentName,
    description,
    documentNumber,
    issueDate,
    issuingOrganization,
  ],
  [DocstoreSections.SUPPORTING]: [
    fileType,
    documentName,
    description,
    documentNumber,
    issueDate,
    issuingOrganization,
  ],
};
